<template>
  <form-row
    :label="title"
    :is-vertical-splitted="false"
  >
    <form-section-question
      slot="question"
    >
      <span
        v-html="subtitle"
      />
    </form-section-question>
  </form-row>
</template>

<script>
export default {
  name: 'direct-marketing-text',
  inject: ['config'],
  props: {
    title: {
      type: String,
      default: null,
    },
    subtitle: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  display: inline-block;

  &:hover { text-decoration: underline; }
}
</style>
